import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';

@Component({
  selector: 'app-preview-modal',
  templateUrl: './preview-modal.component.html',
  styleUrls: ['./preview-modal.component.css']
})
export class PreviewModalComponent implements OnInit {

  @Input() fileUrl : string | undefined;
  @Input() fileName : string | undefined;

  zoom_to : number = 1;
  page : number = 1;

  

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
   //this.fileUrl= new UTILS().getFileUrl(this.fileContent!);
   
  }

  close(){
    this.activeModal.close(false);
  }

  async confirm(){
    this.activeModal.close(true);
  }

  async download() {
    let name = this.fileName + '.pdf';
    //console.log(name);
    new UTILS().downloadFromSource(this.fileUrl!, name!);
  }

  async print() {
    let name = this.fileName + '.pdf';
    new UTILS().printFromSource(this.fileUrl!, name!)
  }

  zoomIn(){
    this.zoom_to= this.zoom_to + 0.25;

  }

  zoomOut() {
    if (this.zoom_to > 1) {
      this.zoom_to = this.zoom_to - 0.25;
   }

  }

  previousPage() {
    if(this.page >1) this.page= this.page - 1;
  }

  nextPage() {
    this.page = this.page + 1;
  }


}
